<template>
  <div
    ref="container"
    class="flex flex-col"
    :style="{
      '--header-height': headerHeight,
      '--header-scroll-height': headerHeight,
    }"
  >
    <LoadingOverlay
      :active="!isLoaded"
      position-type="fixed"
      :delay="isBootLoaded ? 100 : 0"
      class="z-101 h-full"
    >
    </LoadingOverlay>

    <MobileNavigation
      v-if="$windowSize.isMobile && !hideHeader"
      class="fixed bottom-[calc(0.125rem+env(safe-area-inset-bottom))] left-1 z-10 w-[calc(100%-var(--spacing)*2)]"
    />
    <portal-target name="dropdownsContent" multiple> </portal-target>

    <SidebarManager v-if="isBootLoaded" />
    <ModalManager v-if="isBootLoaded" />

    <header
      v-if="!hideHeader"
      class="z-31 w-full"
      :class="{
        fixed: !$windowSize.isMobile && layoutSettings?.header === 'fixed',
        'h-13':
          !$windowSize.isMobile &&
          layoutSettings?.header !== 'sticky' &&
          hideTopBar,
        'h-21':
          !$windowSize.isMobile &&
          layoutSettings?.header !== 'sticky' &&
          !hideTopBar,
        // 'h-8': !$windowSize.isMobile && layoutSettings?.header === 'sticky',
      }"
    >
      <HeaderTop v-if="!hideTopBar" class="bg-white dark:bg-neutral-900" />
      <HeaderBottom
        v-if="!$windowSize.isMobile && layoutSettings?.header !== 'sticky'"
        class=""
      />
    </header>
    <!-- <HeaderBottom
      v-if="!$windowSize.isMobile && layoutSettings?.header === 'sticky'"
      class="sticky top-0 z-20"
    /> -->

    <div
      class="grow"
      :class="{
        'pt-[calc(var(--spacing)*21)]':
          !$route.name?.startsWith('Interactive') &&
          !$windowSize.isMobile &&
          layoutSettings?.header === 'fixed' &&
          !hideHeader &&
          !hideTopBar,

        'pt-[calc(var(--spacing)*14)]':
          !$route.name?.startsWith('Interactive') &&
          !$windowSize.isMobile &&
          layoutSettings?.header === 'fixed' &&
          !hideHeader &&
          hideTopBar,
        'pt-2':
          $windowSize.isMobile &&
          !$route.name?.startsWith('Interactive') &&
          (hideHeader || hideTopBar),
      }"
    >
      <router-view v-if="isBootLoaded" />
    </div>

    <!--       <Stories v-if="stories" @close="closeStories"></Stories>-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import HeaderBottom from '@/components/navigation/HeaderBottom';
import HeaderTop from '@/components/navigation/HeaderTop';
import MobileNavigation from '@/components/navigation/MobileNavigation';
import SidebarManager from '@/components/sidebar/SidebarManager';
import ModalManager from '@/components/modal/ModalManager';
import LoadingOverlay from '@/components/ui/LoadingOverlay';
import '@/assets/fonts/font/stylesheet.css';
import '@/assets/styles/style.scss';

// import Stories from "@/views/stories/Stories";
export default {
  name: 'CatalogLayout',
  components: {
    HeaderTop,
    HeaderBottom,
    MobileNavigation,
    SidebarManager,
    LoadingOverlay,
    ModalManager,
    // Stories,
  },
  data() {
    return {
      langRedirect: false,
    };
  },
  head: {
    meta: [
      { name: 'application-name', content: 'RPT' },
      {
        name: 'viewport',
        content:
          'width=device-width,initial-scale=1.0, shrink-to-fit=no, viewport-fit=cover',
        id: 'meta_viewport',
      },
    ],
    link: [],
    script: [],
    style: [],
  },
  computed: {
    ...mapGetters([
      'isBootLoaded',
      'isLoaded',
      'layoutSettings',
      'catalogSettings',
      'interactiveSettings',
      'currentLanguage',
      'hideHeader',
      'hideTopBar',
    ]),
    headerHeight() {
      if (this.hideHeader) {
        return 0;
      }
      return !this.$windowSize.isMobile
        ? this.hideTopBar
          ? 'calc(var(--spacing)*13)'
          : 'calc(var(--spacing)*21)'
        : '0rem';
    },
  },
  watch: {
    // '$route.name': {
    //   handler: async function (name) {
    // this.scrollY = Math.round(window.scrollY);
    // if (name == 'Main' && this.isBootLoaded) {
    // await this.GET_TOKEN({
    //   token: this.$route.params.token,
    //   projectToken: this.$route.params.projectToken,
    // });
    // this.push({ name: this.main_page, replace: true });
    // this.checkAccessPage();
    // }
    // this.checkFixedHeader(name);
    //   },
    // },

    '$route.params.secondToken': {
      handler: async function (token, oldToken) {
        if (token == oldToken) {
          return;
        }
        await this.LOAD_CATALOG({
          firstToken: this.$route.params.firstToken,
          secondToken: this.$route.params.secondToken,
          lang: this.$route.params.lang,
        });
        this.mainPageRedirect();
      },
    },

    '$route.params.lang': {
      handler: async function (newLang, oldLang) {
        if (this.currentLanguage.name != newLang && (newLang || oldLang)) {
          if (this.langRedirect) {
            this.langRedirect = false;
            return;
          }
          this.CLEAR_INTERACTIVE_CACHE();

          await this.LOAD_CATALOG({
            firstToken: this.$route.params.firstToken,
            secondToken: this.$route.params.secondToken,
            lang: newLang,
          });
        }
      },
    },
  },

  async mounted() {
    this.setCrm();

    if (this.$route.query?.ref) {
      this.SET_PARENT_URL(this.$route.query?.ref);
    }

    if (this.$route.query?.ui) {
      this.PARSE_AND_SET_UI_STATE(this.$route.query?.ui);
    }
    // TODO: (SCRATCH FOR FIXED, STATIC, STICKY HEADER)
    // if (this.layoutSettings?.header !== 'fixed' && !this.$windowSize.isMobile) {
    // this.rootFontSize = parseFloat(
    //   getComputedStyle(document.documentElement).fontSize
    // );
    // this.headerScrollHeight = 0.25 * this.rootFontSize * 21;
    // window.addEventListener('scroll', this.updateScroll, { passive: true });
    // this.updateScroll();
    // }

    const currentRoute = this.$route;
    await this.LOAD_CATALOG({
      firstToken: currentRoute.params.firstToken,
      secondToken: currentRoute.params.secondToken,
      lang: currentRoute.params.lang,
    });

    this.setUtm();
    this.setTrackingData();

    this.langCheckRedirect();
    this.mainPageRedirect();
    this.INIT_FULLSCREEN_LISTENER();
  },
  beforeDestroy() {
    this.REMOVE_FULLSCREEN_LISTENER();
  },

  methods: {
    // ...mapActions(['OPEN_STORIES', 'CLOSE_STORIES']),
    // openStories() {
    //   this.OPEN_STORIES();
    // },
    // closeStories() {
    //   this.CLOSE_STORIES();
    // },
    ...mapActions([
      'CLEAR_INTERACTIVE_CACHE',
      'SET_CRM',
      'SET_IS_ADMIN',
      'SET_PARENT_URL',
      'SET_UTM',
      'SET_TRACKING_DATA',
      'LOAD_CATALOG',
      'PARSE_AND_SET_UI_STATE',
      'INIT_FULLSCREEN_LISTENER',
      'REMOVE_FULLSCREEN_LISTENER',
    ]),

    langCheckRedirect() {
      const currentRoute = this.$route;
      const params = { ...currentRoute.params };

      if (
        this.currentLanguage.name != currentRoute.params.lang &&
        currentRoute.params.lang
      ) {
        this.langRedirect = true;
        params.lang = this.currentLanguage.name;
        this.routerReplace({
          name: currentRoute.name,
          params,
          query: currentRoute.query,
        });
      }
    },

    mainPageRedirect() {
      if (this.$route.name !== 'Main') {
        return;
      }
      if (this.catalogSettings.main_page !== 'Interactive') {
        this.routerReplace({ name: this.catalogSettings.main_page });
        return;
      }
      this.routerReplace({
        name: 'Interactive',
        params: {
          frameId: this.interactiveSettings.default_frame_id,
          interactiveId: this.interactiveSettings.default_id,
        },
      });
    },

    setUtm() {
      this.SET_UTM({
        utm_source: this.$route.query.utm_source
          ? this.$route.query.utm_source
          : '',
        utm_campaign: this.$route.query.utm_campaign
          ? this.$route.query.utm_campaign
          : '',
        utm_content: this.$route.query.utm_content
          ? this.$route.query.utm_content
          : '',
        utm_medium: this.$route.query.utm_medium
          ? this.$route.query.utm_medium
          : '',
        utm_term: this.$route.query.utm_term ? this.$route.query.utm_term : '',
      });
    },
    setTrackingData() {
      this.SET_TRACKING_DATA({
        yclid: this.$route.query.yclid ? this.$route.query.yclid : '',
        gclid: this.$route.query.gclid ? this.$route.query.gclid : '',
        referrer: this.$route.query.referrer
          ? decodeURIComponent(this.$route.query.referrer)
          : '',
      });
    },

    setCrm() {
      if (
        this.$route.query?.domain &&
        this.$route.query?.status_id &&
        (this.$route.query?.amo ||
          this.$route.query?.b24 ||
          this.$route.query?.rptcrm)
      ) {
        let crm = {
          domain: this.$route.query?.domain,
          status_id: this.$route.query?.status_id,
          lead_type: 'deal',
          category_id: 0,
        };

        // if (this.$route.query?.rptcrm) {
        //   crm.type = 'RptCrm';
        //   crm.id = this.$route.query?.lead_id;
        //   crm.crm_id = this.$route.query?.rptcrm;
        // }

        if (this.$route.query?.amo) {
          crm.type = 'AmoCRM';
          crm.id = this.$route.query?.amo;
        }

        if (this.$route.query?.b24) {
          crm.type = 'Bitrix24';
          crm.id = this.$route.query?.b24;
          crm.lead_type = this.$route.query?.lead_type;
          crm.category_id = this.$route.query?.category_id;
        }

        this.SET_CRM(crm);
        this.SET_IS_ADMIN(true);
      }
    },

    checkFixedHeader(name) {
      if (name.startsWith('Interactive')) {
        document.body.classList.add('fixed-header');
        return;
      }
      document.body.classList.remove('fixed-header');
    },
  },
};
</script>

<style lang="scss"></style>
